if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      // if (!opener.hasAttribute("data-product-url")){
      //   super.show(opener);
      //   return;
      // };

      if (opener.disabled) return;
      const modalOpener = opener.closest('.quick-add');
      modalOpener?.querySelector('[data-quickshop-error]')?.remove();
      if (modalOpener) modalOpener.classList.add('quick-add--visible');
      opener.classList.add('btn--loading');
      opener.setAttribute('aria-disabled', true);
      opener.setAttribute('disabled', true);

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => {
          if (!response.ok) throw new Error('Unable to load product options');
          return response.text();
        })
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          const source = responseHTML.getElementById("quick-buy-content");
          if (!source?.content) throw new Error('Missing product options');
          const quickBuyContent = source.content;
          Array.from(quickBuyContent.querySelectorAll("noscript")).forEach((noScript) => noScript.remove());
          this.modalContent.replaceChildren(quickBuyContent);

          const imgsElm = this.modalContent.querySelectorAll('img');

          imgsElm.forEach((imgElm) => {
            imgElm.onload = () => {
              imgElm.classList.add('loaded');
            }
          });

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();
          setTimeout(() => {
            super.show(opener);
          });
        })
        .catch(() => {
          const message = document.createElement('p');
          message.dataset.quickshopError = '';
          message.setAttribute('role','alert');
          message.textContent = window.cartStrings.error;
          (modalOpener || opener.parentElement).appendChild(message);
        })
        .finally(() => {
          if (modalOpener) modalOpener.classList.remove('quick-add--visible');
          opener.removeAttribute('aria-disabled');
          opener.removeAttribute('disabled');
          opener.classList.remove('btn--loading');
        });
    }
  });
}
